import { UserSelect } from "@/containers/Project/components";
import * as S from "@/containers/Project/components/styled";
import { ProjectMilestoneStatus } from "@/enums";
import { trimText } from "@/helpers";
import { projectMilestoneType } from "@/propTypes";
import { useProjectContext, useUserContext } from "@/providers";
import { FlexDiv } from "@/sharedStyled";
import { faCircleCheck, faComment } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Space, Tooltip } from "antd";
import { object, string } from "prop-types";
import { useIntl } from "react-intl";
import { checkIsFinalApproverNeeded } from "./helper";

const COMMENT_CHAR_LIMIT = 60;

export const MilestoneUser = ({ milestone, user, dataTestId }) => {
  const intl = useIntl();

  const {
    setMilestoneStatusActionCommentModal,
    project: { projectLeaders } = {},
  } = useProjectContext();
  const { userToken } = useUserContext();

  const openStatusChangeModal = (status) => {
    setMilestoneStatusActionCommentModal({
      milestoneId: milestone.id,
      targetStatus: status,
      finalApprover:
        status === ProjectMilestoneStatus.Approved
          ? checkIsFinalApproverNeeded(
              userToken.user.id,
              milestone,
              projectLeaders
            )
          : false,
    });
  };

  const showButtons =
    milestone.status === ProjectMilestoneStatus.InApproval &&
    user.userId === userToken.user.id &&
    !user.approved;

  return (
    <div className="pb-2" key={user.userId}>
      <FlexDiv>
        <S.ApproverInputContainer>
          <UserSelect
            users={[user.userId]}
            readOnly={true}
            dataTestId={dataTestId}
          />
        </S.ApproverInputContainer>
        <S.ApproverActionsContainer>
          {showButtons && (
            <Space direction="horizontal" size="small">
              <Button
                ghost
                type="primary"
                data-test-id={"milestone-approvers-view-reject-btn"}
                onClick={() =>
                  openStatusChangeModal(ProjectMilestoneStatus.Rejected)
                }
              >
                {intl.formatMessage({
                  id: "general.reject",
                })}
              </Button>
              <Button
                ghost
                type="primary"
                data-test-id={"milestone-approvers-view-reject-btn"}
                onClick={() =>
                  openStatusChangeModal(ProjectMilestoneStatus.Approved)
                }
              >
                {intl.formatMessage({
                  id: "general.approve",
                })}
              </Button>
            </Space>
          )}
          {!showButtons && user.approved && (
            <S.ApproverIconContainer>
              <Tooltip
                title={intl.formatMessage({
                  id: "general.approved",
                })}
              >
                <FontAwesomeIcon icon={faCircleCheck} color={"green"} />
              </Tooltip>
              {user.approvalComment && (
                <Tooltip
                  title={trimText(user.approvalComment, COMMENT_CHAR_LIMIT)}
                >
                  <FontAwesomeIcon
                    icon={faComment}
                    color={"var(--ant-primary-color)"}
                  />
                </Tooltip>
              )}
            </S.ApproverIconContainer>
          )}
        </S.ApproverActionsContainer>
      </FlexDiv>
    </div>
  );
};

MilestoneUser.propTypes = {
  milestone: projectMilestoneType.isRequired,
  user: object.isRequired,
  dataTestId: string.isRequired,
};
